var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "bot-image-message" },
      on: {
        mouseenter: function ($event) {
          _vm.hovered = true
        },
        mouseleave: function ($event) {
          _vm.hovered = false
        },
      },
    },
    [
      _c(
        "viewer",
        {
          attrs: {
            id: "imageViewer-" + _vm.data.raw.uniqMessageId,
            images: [_vm.imageSrc()],
          },
        },
        [
          _c(
            "div",
            { staticClass: "cb-img-preview", on: { click: _vm.show } },
            [
              _c("img", {
                staticClass:
                  "img-thumbnail ant-upload-list-picture-card-container",
                staticStyle: { "object-fit": "cover" },
                attrs: {
                  id: "img-" + _vm.data.raw.uniqMessageId,
                  src: _vm.imageSrc(),
                },
              }),
              _vm._v(" "),
              _vm.hovered
                ? _c(
                    "md-icon",
                    { staticClass: "cb-pr-icon", on: { click: _vm.show } },
                    [_vm._v(" visibility")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.data.data.meta
        ? _c("span", { staticClass: "message" }, [
            _vm._v(_vm._s(_vm.data.data.meta)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }